const survey = {
    en: {
        "survey.title": "Surveys",
        "survey.create": "Create survey",
        "survey.name": "Title",
        "survey.description": "Description",
        "survey.questions": "Questions",
        "survey.question": "Question",
        "survey.addQuestion": "Add question",
        "survey.type": "Type",
        "survey.single": "Single choice",
        "survey.text": "Free text",
        "survey.options": "Options (comma-separated)",
        "survey.save": "Save survey",
        "survey.cancel": "Cancel",
        "survey.none": "No surveys yet",
        "survey.responses": "Responses",
        "survey.active": "Active",
        "survey.closed": "Closed",
        "survey.open": "Open",
        "survey.viewResults": "Results",
        "survey.close": "Close",
        "survey.reopen": "Reopen",
        "survey.delete": "Delete",
        "survey.fill": "Fill in",
        "survey.answered": "Answered",
        "survey.submit": "Submit",
        "survey.submitted": "Thank you! Your response was saved.",
        "survey.results": "Results",
        "survey.totalResponses": "Total responses",
        "survey.noResponses": "No responses yet",
        "survey.back": "Back",
        "survey.confirmDelete": "Delete this survey and all responses?",
        "survey.selectAnswer": "Select an answer",
        "survey.yourAnswer": "Your answer",
    },
    ru: {
        "survey.title": "Опросы",
        "survey.create": "Создать опрос",
        "survey.name": "Заголовок",
        "survey.description": "Описание",
        "survey.questions": "Вопросы",
        "survey.question": "Вопрос",
        "survey.addQuestion": "Добавить вопрос",
        "survey.type": "Тип",
        "survey.single": "Один выбор",
        "survey.text": "Свободный текст",
        "survey.options": "Варианты (через запятую)",
        "survey.save": "Сохранить опрос",
        "survey.cancel": "Отмена",
        "survey.none": "Опросов пока нет",
        "survey.responses": "Ответы",
        "survey.active": "Активен",
        "survey.closed": "Закрыт",
        "survey.open": "Открыть",
        "survey.viewResults": "Результаты",
        "survey.close": "Закрыть",
        "survey.reopen": "Открыть снова",
        "survey.delete": "Удалить",
        "survey.fill": "Заполнить",
        "survey.answered": "Отвечено",
        "survey.submit": "Отправить",
        "survey.submitted": "Спасибо! Ваш ответ сохранён.",
        "survey.results": "Результаты",
        "survey.totalResponses": "Всего ответов",
        "survey.noResponses": "Ответов пока нет",
        "survey.back": "Назад",
        "survey.confirmDelete": "Удалить опрос и все ответы?",
        "survey.selectAnswer": "Выберите ответ",
        "survey.yourAnswer": "Ваш ответ",
    },
    geo: {
        "survey.title": "გამოკითხვები",
        "survey.create": "გამოკითხვის შექმნა",
        "survey.name": "სათაური",
        "survey.description": "აღწერა",
        "survey.questions": "კითხვები",
        "survey.question": "კითხვა",
        "survey.addQuestion": "კითხვის დამატება",
        "survey.type": "ტიპი",
        "survey.single": "ერთი არჩევანი",
        "survey.text": "თავისუფალი ტექსტი",
        "survey.options": "ვარიანტები (მძიმით გამოყოფილი)",
        "survey.save": "გამოკითხვის შენახვა",
        "survey.cancel": "გაუქმება",
        "survey.none": "გამოკითხვები ჯერ არ არის",
        "survey.responses": "პასუხები",
        "survey.active": "აქტიური",
        "survey.closed": "დახურული",
        "survey.open": "გახსნა",
        "survey.viewResults": "შედეგები",
        "survey.close": "დახურვა",
        "survey.reopen": "ხელახლა გახსნა",
        "survey.delete": "წაშლა",
        "survey.fill": "შევსება",
        "survey.answered": "პასუხგაცემული",
        "survey.submit": "გაგზავნა",
        "survey.submitted": "გმადლობთ! თქვენი პასუხი შენახულია.",
        "survey.results": "შედეგები",
        "survey.totalResponses": "სულ პასუხები",
        "survey.noResponses": "პასუხები ჯერ არ არის",
        "survey.back": "უკან",
        "survey.confirmDelete": "წავშალო გამოკითხვა და ყველა პასუხი?",
        "survey.selectAnswer": "აირჩიეთ პასუხი",
        "survey.yourAnswer": "თქვენი პასუხი",
    },
};

export default survey;
